import AbstractModuleFactory from '@core/shared/module-factory';
import GetInvoiceProfileUseCase from './use-cases/GetInvoiceProfile';
import InvoiceProfileService from './services';
import UserService from '../User/services/User';

export class InvoiceProfileModuleFactory extends AbstractModuleFactory {
  creatGetInvoiceProfileUseCase(): GetInvoiceProfileUseCase {
    return this.ensureInstance('GetInvoiceProfileUseCase', () => new GetInvoiceProfileUseCase(new InvoiceProfileService(), new UserService()));
  }

  static new(): InvoiceProfileModuleFactory {
    return new InvoiceProfileModuleFactory();
  }
}

export default InvoiceProfileModuleFactory.new();
